/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type MonthsEnum = 'Jan' | 'Feb' | 'Mar' | 'Apr' | 'May' | 'Jun' | 'Jul' | 'Aug' | 'Sep' | 'Oct' | 'Nov' | 'Dec';

export const MonthsEnum = {
    Jan: 'Jan' as MonthsEnum,
    Feb: 'Feb' as MonthsEnum,
    Mar: 'Mar' as MonthsEnum,
    Apr: 'Apr' as MonthsEnum,
    May: 'May' as MonthsEnum,
    Jun: 'Jun' as MonthsEnum,
    Jul: 'Jul' as MonthsEnum,
    Aug: 'Aug' as MonthsEnum,
    Sep: 'Sep' as MonthsEnum,
    Oct: 'Oct' as MonthsEnum,
    Nov: 'Nov' as MonthsEnum,
    Dec: 'Dec' as MonthsEnum
};

